import React, {useEffect, useState} from 'react';
import propTypes from 'prop-types';
import Modal from 'react-modal';
import {connect} from 'react-redux';
import moment from 'moment';
import TablePagination from 'components/TablePagination';
import config from '../../../../../config';

import HistoryTable from './HistoryTable';
import SelectedConversationHistory, {generalStyles} from './ConversationHistory';
import getHistoryPage from './api';
import {filterByStatus, returnIDs, returnIDsWithoutPushing, titleStyles} from '../../../../../utils/General';
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested,
} from '../../../../../services/chat/action';
import Translate, {t} from '../../../../../components/Translate';
import './index.css';
import SearchIcon from "../../../../../assets/SearchIcon";
import {confirmActionRequested} from '../../../../../services/confirmAction/action';
import ConfirmModalHistory from '../../../../../components/ConfirmModalHistory';

const styles = {
    wrapper: {
        padding: '40px 60px',
        background: '#FFFFFF',
        overflow: 'auto',
        height: '100vh',
        borderRadius: '20px',
        margin: '30px',
        maxHeight: 'calc(100vh - 125px)',
    },
    header: {
        color: '#3D568F',
        fontSize: '22px',
        marginBottom: '50px',
    },
};

const History = ({
                     user,
                     company,
                     conversation,
                     clearSelectedConversationFromStore,
                     selectConversation,
                     loadOlderMessages,
                     confirmAction
                 }) => {
    const {subs, members} = company;

    const [selectedClientIds, setSelectedClientIds] = useState(returnIDsWithoutPushing(subs));
    const [selectedOperatorsIds, setSelectedOperatorsIds] = useState(returnIDs(filterByStatus(members, config.statusMap.enabled)));
    const [selectedStatuses, setSelectedStatuses] = useState(config.conversationStatusesList);
    const [selectedChannel, setSelectedChannel] = useState(['WEBCHAT', 'TELEGRAM', 'MESSENGER', 'WEBEX', 'WHATSAPP', 'INSTAGRAM']);
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [startDate, setStartDate] = useState(moment().subtract(365, 'days').toDate());
    const [endDate, setEndDate] = useState(moment().add(1, 'day').toDate());
    const [orderBy, setOrderBy] = useState('DATE');
    const [ordering, setOrdering] = useState('DESC');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(null);
    const [conversationsList, setConversationsList] = useState([]);
    const [categoryName, setCategoryName] = useState("")
    const [userKey, setUserKey] = useState("")
    const [searchValue, setSearchValue] = useState("")

    useEffect(() => {
        getHistoryPageData();
    }, [userKey,
        selectedClientIds,
        selectedOperatorsIds,
        selectedChannel,
        selectedStatuses,
        selectedCustomer,
        startDate,
        endDate,
        orderBy,
        ordering,
        currentPage,
        rowsPerPage]);

    const getHistoryPageData = () => {
        const options = {
            userKey: userKey,
            companies: selectedClientIds,
            operatorIds: selectedOperatorsIds,
            platforms: selectedChannel,
            statuses: selectedStatuses,
            name: selectedCustomer,
            startDate,
            endDate,
            orderBy,
            ordering,
            page: currentPage,
            size: rowsPerPage,
            categoryName: categoryName,
            searchValue: searchValue
        };

        getHistoryPage(options).then((conversationsList) => {
            setTotalRows(conversationsList.count);
            setConversationsList(conversationsList.conversationInfo);
        });
    };

    const closeConversationHistory = () => {
        clearSelectedConversationFromStore();
    };

    const showConversationHistory = (conversationInfo) => {
        selectConversation({
            id: conversationInfo.conversationId,
            companyId: conversationInfo.companyId,
            platform: conversationInfo.platform,
            userFirstName: conversationInfo.customerName,
            userThumbUrl: conversationInfo.visitorThumbUrl
        });
    };

    const handleFilterChange = (key, value) => {
        switch (key) {
            case 'selectedClientIds':
                setSelectedClientIds(value);
                setCurrentPage(1);
                break;
            case 'selectedOperatorsIds':
                setSelectedOperatorsIds(value);
                setCurrentPage(1);
                break;
            case 'selectedChannel':
                setSelectedChannel(value);
                setCurrentPage(1);
                break;
            case 'selectedStatuses':
                setSelectedStatuses(value);
                setCurrentPage(1);
                break;
            case 'selectedCustomer':
                setSelectedCustomer(value);
                setCurrentPage(1);
                break;
            case 'orderBy':
                setOrderBy(value);
                setCurrentPage(1);
                break;
            case 'ordering':
                setOrdering(value);
                setCurrentPage(1);
                break;
            default:
                break;
        }
    };

    const handleDateChange = (startDate, endDate) => {
        setStartDate(startDate);
        setEndDate(endDate);
        setCurrentPage(1);
    };

    const handleChangePage = (page) => {
        setCurrentPage(page + 1);
    };

    const handleChangeRawsPerPage = (rows) => {
        setRowsPerPage(rows);
    };

    const handleUserKeySearch = (userKey) => {
        setUserKey(userKey)
        setCurrentPage(1);
    }

    const handleSearchByMessage = () => {
        getHistoryPageData();
        setCurrentPage(1);
    };

    const handleCategorySearch = () => {
        getHistoryPageData();
        setCurrentPage(1);
    }

    const {language} = user;

    const openTrModal = (conversation, showConversationHistory) => {
        confirmAction({
                content: <ConfirmModalHistory company={company} showConversationHistory={showConversationHistory}
                                              conversation={conversation}/>
            }
        );
    };

    return (
        <div style={styles.wrapper}>
            <h2 style={titleStyles.title}>
                <Translate text="history"/>
            </h2>

            <div>
                <div className="history-search-by-message-div">
                    <input value={searchValue}
                           onChange={(e) => {
                               setSearchValue(e.target.value);
                           }}
                           placeholder={t({text: "searchByMessage", user})}
                           className="history-search-by-message"/>
                    <button
                        type="button"
                        onClick={handleSearchByMessage}
                    >
                        <SearchIcon width="20px" height="20px" fill="#fff"/>
                    </button>
                </div>

                <div className="history-search-by-message-div">
                    <input value={categoryName}
                           onChange={(e) => {
                               setCategoryName(e.target.value)
                           }}
                           placeholder={t({text: "searchByCategory", user})}
                           className="history-search-by-message"/>
                    <button
                        type="button"
                        onClick={handleCategorySearch}
                    >
                        <SearchIcon width="20px" height="20px" fill="#fff"/>
                    </button>
                </div>
            </div>

            <HistoryTable
                user={user}
                openTrModal={openTrModal}
                handleUserKeySearch={handleUserKeySearch}
                handleCategorySearch={handleCategorySearch}
                company={company}
                conversationsList={conversationsList}
                showConversationHistory={showConversationHistory}
                handleFilterChange={handleFilterChange}
                selectedClientIds={selectedClientIds}
                selectedOperatorsIds={selectedOperatorsIds}
                selectedChannel={selectedChannel}
                selectedStatuses={selectedStatuses}
                selectedCustomer={selectedCustomer}
                language={language}
                startDate={startDate}
                endDate={endDate}
                handleDateChange={handleDateChange}
            />
            <TablePagination
                totalRows={totalRows}
                numberOfPages={Math.ceil(totalRows / rowsPerPage)}
                rowsPerPage={rowsPerPage}
                curPage={currentPage - 1}
                selectPage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRawsPerPage}
            />
            <Modal
                closeTimeoutMS={config.closeTimeoutMS}
                style={generalStyles.modalStyles}
                isOpen={conversation.id !== null}
                onRequestClose={closeConversationHistory}
            >
                <SelectedConversationHistory
                    tariff={company.tariff}
                    conversation={conversation}
                    user={user}
                    company={company}
                    loadOlderMessages={loadOlderMessages}
                    closeWindow={closeConversationHistory}
                />
            </Modal>
        </div>
    );
};

History.propTypes = {
    user: propTypes.object.isRequired,
    company: propTypes.object.isRequired,
    conversation: propTypes.object.isRequired,
    clearSelectedConversationFromStore: propTypes.func.isRequired,
    selectConversation: propTypes.func.isRequired,
    loadOlderMessages: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(mapStateToProps, mapDispatchToProps)(History);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/index.jsx